

import React from 'react';
import { FiArrowLeft } from 'react-icons/fi'; // Import an icon for the back button
import Footer from './Footer';

export default function SingleArticle({ article, goBack }) {
  return (
    <div>
    <div className="py-20 px-4 md:mt-4 mt-6 lg:py-28 max-w-6xl mx-auto">
      {/* Go Back Button with Icon */}
    

      <div className="bg-white shadow-lg rounded-sm overflow-hidden">
        {/* Article Image */}
        <img
          src={article.imgSrc}
          alt={article.title}
          className="w-full md:h-[600px] h-[200px] object-cover"
        />

        <div className="p-8">
          {/* Article Title */}
          <h1 className="text-4xl font-extrabold text-gray-800 mb-6">
            {article.title}
          </h1>

          {/* Author and Date */}
          <div className="flex items-center text-gray-500 space-x-6 mb-6">
            {/* <p className="text-lg font-medium">{article.author}</p> */}
            <p className="text-lg">{article.date}</p>
          </div>

          {/* Article Content */}
          <div
              className="text-lg leading-relaxed text-gray-700 mb-8"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

          {/* Article Gallery */}
          {article.gallery && article.gallery.length > 0 && (
  <div className="gallery grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4 mt-8">
    {article.gallery.map((image, index) => (
      <div key={index} className="flex flex-col items-center">
        <img
          src={image.src}
          alt={`Gallery image ${index + 1}`}
          className="w-full h-128 object-cover rounded-lg transition-transform duration-300 hover:scale-55"
        />
        <p className="mt-2 text-md font-bold text-gray-600">{image.caption}</p>
      </div>
    ))}
  </div>
)}

        </div>
       
      </div>
    </div>
    <div className="flex justify-center">
  <button
    onClick={goBack}
    className="flex items-center mt-4 space-x-2 mb-8 px-4 py-2 bg-white text-white rounded-full shadow hover:bg-indigo-700 transition-all duration-200 focus:outline-none"
  >
    <FiArrowLeft className="text-xl text-black" />
    <span className="text-sm text-black font-semibold">Back to Articles</span>
  </button>
</div>

     <Footer/>
    </div>
  );
}
